/**
 * Maintained by Sandon.
 */
import {defaultProps, Modes} from './index'
import {genMap} from './utils'

// 这里的mixin是和selector相关的，涉及：依赖于selectedData、搜索功能
// 使用的组件：tree-selector/cascade-selector
const selectorMixin = {
  data () {
    return {
      realSelectedKeys: [...this.selectedKeys],
      visible: false,
      shouldTreeCreate: !this.lazy, // tree组件是否创建：懒加载时，延迟到第一次展示时创建，目的是为了延迟发送第一级请求
      keys: Object.assign({}, defaultProps, this.props),
      // 选中数据的完整模型
      selectedNodes: {
        completeNodes: [],
        simpleNodes: [],
        complete: [],
        simple: [],
        unInitSelectedKeys: []
      },
      showedSelectedNodes: [], // 选中的节点，包含树节点+懒加载的节点
      preSelectedKeys: [],
      
      // 搜索相关
      filterKw: '', // 搜索词
      filterItems: []
    }
  },
  created () {
    this.keys = Object.assign(this.keys, {completeLabel: 'completeLabel', tip: 'tip'})
    
    if (this.mode === Modes.TWO_WAY && this.mustLeaf) {
      this.mode = Modes.SEPARATE
    }
    
    if (this.lazy) {
      this._updateUnInitSelectedKeys()
      this._change(true) // 构建 showedSelectedNodes 等
    }
  },
  watch: {
    selectedKeys: function () {
      this.realSelectedKeys = [...this.selectedKeys]
    },
    realSelectedKeys: function () {
      // tree 还没创建时，接管 unInitSelectedKeys 的修改
      if (!this.shouldTreeCreate) {
        this._updateUnInitSelectedKeys()
        this._change(true) // unInitSelectedKeys变化，进而构建 showedSelectedNodes 等
      }
    }
  },
  methods: {
    // 获取 core 引用，注意使用的地方都要确保 tree 已经渲染了
    _getCoreRef () {
      return this.$refs['core']
    },
    // 更新 unInitSelectedKeys
    _updateUnInitSelectedKeys () {
      this.selectedNodes.unInitSelectedKeys =
        !this.realSelectedKeys.length
          ? []
          : this.multiple
            ? [...this.realSelectedKeys]
            : [this.realSelectedKeys[0]]
    },
    // for key
    _getKey (node) {
      return node._isTreeNode ? node.key : node[this.keys['key']]
    },
    // 节点是否 disable
    _nodeDisabled (node) {
      const key = node._isTreeNode ? node.key : node[this.keys['key']]
      return this.disabledKeysSet.has(key)
    },
    // 根据selectedData获取展示节点
    _getUninitShowedNodes (keys) {
      if (!keys || !keys.length || !this.selectedData) return []

      const unInitShowedNodes = new Set()
      const keyPropName = this.keys['key']
      const selectedDataMap = genMap(this.selectedData, keyPropName)
      keys.forEach((key) => {
        if (selectedDataMap[key]) {
          unInitShowedNodes.add(selectedDataMap[key])
        }
      })
      return [...unInitShowedNodes]
    },
    // 节点的展示
    _getShowText (treeNode, forceComplete = false) {
      if (!treeNode) return ''

      if (treeNode._isTreeNode) {
        let text = [treeNode.label]
        if (this.showComplete || forceComplete) {
          let node = treeNode.parent
          while (node && node.parent) {
            text.push(node.label)
            node = node.parent
          }
        }
        return text.reverse().join(this.labelDivider !== '/' ? this.labelDivider : this.showDivider)
      } else {
        const labelKey = this.keys['label']
        return treeNode[labelKey] || ''
      }
    },
    // 用户操作来删除某项, 以key来删除
    _del (key, completeSearch = false) {
      let node
      if (completeSearch) {
        node = this.selectedNodes.completeNodes.find(_ => _.key === key)
      } else {
        node = this.selectedNodes.simpleNodes.find(_ => _.key === key)
      }
      if (node) {
        if (this.multiple) {
          this._getCoreRef()._updateCheckedMultiple(node, false) // todo down 模式
        } else {
          this._getCoreRef()._updateSelectedNodesSingle(null, false, this._close.bind(this), true)
        }
      } else {
        // 非树中节点，改数据
        // this.selectedNodes.unInitSelectedKeys =
        //   this.selectedNodes.unInitSelectedKeys.filter(_ => _ !== key)
        // this._change(false)
        this.realSelectedKeys = this.realSelectedKeys.filter(_ => _ !== key)
        this.$nextTick(() => { this._change(false) })
        
        // todo 和_delTag 一样的处理
      }
    },
    // 用户删除tag来删除某项, 以 Node | Data 来删除 - pc todo 移到pc-selector-mixin
    _delTag (nodeOrData) {
      if (nodeOrData._isTreeNode) {
        // 树中节点
        const key = nodeOrData.key
        const leftNodes = this.selectedNodes.simpleNodes
          .filter((node) => node.key !== key)
        const leftKeys = leftNodes.map(node => node.key)
        this._getCoreRef().setCheckedKeys(leftKeys, true)
      } else {
        // 非树中节点，改数据
        const key = nodeOrData[this.keys.key]
        
        // todo
        // this.selectedNodes.unInitSelectedKeys =
        //   this.selectedNodes.unInitSelectedKeys.filter(id => id !== key)
        // this._change(false)
  
        this.realSelectedKeys = this.realSelectedKeys.filter(_ => _ !== key)
        this.$nextTick(() => { this._change(false) })
        
        // 思考，选了第一种逻辑
        // 一种逻辑：修改 realSelectedKeys 会触发 core 的重新渲染 或 初始渲染正确
        // 另一种逻辑：修改 unInitSelectedKeys，并同步给core（在core已创建后），如果此时core还没创建，那只能通过 realSelectedKeys
      }
    },
    // 透传 checkbox-click 事件
    _checkboxClick (node) {
      this.$emit('checkbox-click', node)
    },
    
    // 搜索相关函数
    // 判断条目是否选中
    _isSelected (key) {
      if (this.selectedNodes.completeNodes.findIndex(node => node.key === key) !== -1) {
        return true
      } else {
        return this.selectedNodes.unInitSelectedKeys.findIndex(id => id === key) !== -1
      }
    },
    // 搜索词更新
    _filterUpdate (filterKw, cb) {
      this.filterKw = filterKw
      this.$emit('filter', this.filterKw)
      
      if (this.filterKw.length && !this.lazy && !this.filterItems.length) {
        this._genFilterItems()
      }
      
      cb && cb()
    },
    // 生成 filterItems
    _genFilterItems () {
      const filterItems = []
      let arr = [this._getCoreRef().root]
      for (let i = 0; i !== arr.length; i++) {
        arr = arr.concat(arr[i].childNodes)
    
        if (!arr[i].parent) continue // root
        if (this.mustLeaf) {
          arr[i].isLeaf && filterItems.push(arr[i])
        } else {
          filterItems.push(arr[i])
        }
      }
      // 目标节点取决于是否必须是叶子节点
      this.filterItems = filterItems
    },
    // 点击搜索条目
    _clickFilterItem (item) {
      const isSelected = this._isSelected(item.key)
      if (isSelected) {
        this._del(item.key, true)
      } else {
        if (this.remoteFilter) {
          const keyPropName = this.keys['key']
          const labelPropName = this.keys['label']
          let exist = this.selectedData.find(data => data[keyPropName] === item.key)
          if (!exist) {
            this.selectedData.push({
              [keyPropName]: item.key,
              [labelPropName]: item.label
            })
          }
        }
        this._select(item.key)
      }
      
      // clearFilter 为 true 时清空搜索词
      if (this.clearFilter && this.multiple && this.filterKw.length) {
        this.$refs['magicInput']?.clearFilter()
        this.$refs['magicInput']?.focus()
      }
    },
    // 基于key选中某一项
    _select (key) {
      let node
      let arr = [this._getCoreRef().root]
      for (let i = 0; i !== arr.length; i++) {
        if (arr[i].key === key) {
          node = arr[i]
          break
        }
  
        arr = arr.concat(arr[i].childNodes)
      }
      
      if (node) {
        if (this.multiple) {
          this._getCoreRef()._updateCheckedMultiple(node, true) // todo down 模式
        } else {
          this._getCoreRef()._updateSelectedNodesSingle(node, false, null, true)
        }
      } else {
        if (this.multiple) {
          this.realSelectedKeys.push(key)
        } else {
          this.realSelectedKeys = [key]
        }
        this.$nextTick(() => { this._change(false) })
      }
  
      !this.multiple && this._close()
    }
  }
}

export default selectorMixin